import { useTranslation } from "react-i18next";
import { useAuth } from "~/contexts/auth-context";
import { Badge } from "~/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { Text } from "~/components/text";

export const CompanyBadge = () => {
  const { session } = useAuth();
  const { t } = useTranslation("settings");
  const organisationName = session?.organisation.name;

  if (!organisationName) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge
          variant="secondary"
          className="cursor-default"
          data-testid="company-badge"
        >
          {organisationName}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <Text variant="caption">{t("organisation.tooltip")}</Text>
      </TooltipContent>
    </Tooltip>
  );
};
